import React from "react";
import { Paper, Stack, Typography, Box, Skeleton } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HotelIcon from "@mui/icons-material/Hotel";

const ICON_MAP = {
  GroupIcon: GroupIcon,
  AttachMoneyIcon: AttachMoneyIcon,
  WarningAmberIcon: WarningAmberIcon,
  LocalHospitalIcon: LocalHospitalIcon,
  ExitToAppIcon: ExitToAppIcon,
  HotelIcon: HotelIcon,
};

/**
 * Card individual de KPI para los 6 segmentos principales.
 * Clickeable para navegar a la vista correspondiente.
 */
export default function KpiSegmentCard({
  label,
  value,
  icon,
  color,
  bgColor,
  loading,
  onClick,
}) {
  if (loading) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 2,
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Stack spacing={1}>
          <Skeleton variant="circular" width={36} height={36} />
          <Skeleton variant="text" width="60%" height={32} />
          <Skeleton variant="text" width="80%" />
        </Stack>
      </Paper>
    );
  }

  const IconComponent = ICON_MAP[icon] || GroupIcon;

  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 2,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        cursor: onClick ? "pointer" : "default",
        transition: "all 200ms ease",
        "&:hover": onClick
          ? {
              boxShadow: `0 4px 12px rgba(0,0,0,0.08)`,
              borderColor: color,
              transform: "translateY(-2px)",
            }
          : {},
      }}
    >
      <Stack spacing={1}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 36,
            height: 36,
            borderRadius: 2,
            bgcolor: bgColor,
            color: color,
          }}
        >
          <IconComponent sx={{ fontSize: 20 }} />
        </Box>

        <Typography
          variant="h5"
          fontWeight={800}
          sx={{ color, lineHeight: 1.1 }}
        >
          {typeof value === "number" ? value.toLocaleString() : value}
        </Typography>

        <Typography
          variant="caption"
          color="text.secondary"
          fontWeight={600}
          sx={{ textTransform: "uppercase", letterSpacing: 0.5, fontSize: "0.65rem" }}
        >
          {label}
        </Typography>
      </Stack>
    </Paper>
  );
}
